import _ from 'lodash';
import { remoteSpotSlugNotFoundStatus, useSpotAPI } from '../../apis/spot-api';
import { useStorage } from '../../hooks/use-storage';

function useSpotManager() {
  const { loadSpotFromRemote } = useSpotAPI();
  const { spotRef, userRef, setSpot } = useStorage();

  async function checkCurrentSpot(clearSpot = () => {}) {
    if (spotRef.current != null) {
      const response = await loadSpotFromRemote(spotRef.current.id);

      if (
        response.status === remoteSpotSlugNotFoundStatus ||
        response.data.hidden === true
      ) {
        clearSpot();
      }

      return response;
    }

    return {
      data: spotRef.current,
    };
  }

  function parseSpotFromOrder(orders) {
    if (!_.isEmpty(orders)) {
      return (
        _.head(
          orders?.filter((o) => o.bill?.customer?.id === userRef.current?.id)
        )?.bill?.spot ?? _.head(orders)?.bill?.spot
      );
    }

    return null;
  }

  async function checkSpotChange(orders, callback) {
    const spotFromOrder = parseSpotFromOrder(orders);

    if (
      spotRef.current != null &&
      spotFromOrder != null &&
      spotRef.current.id !== spotFromOrder.id
    ) {
      setSpot(spotFromOrder);

      await callback?.call(this, spotFromOrder);

      // await showSpotTransferModal(spotFromOrder);
      // analyticsPageView("Bill");
    }
  }

  return {
    checkCurrentSpot,
    parseSpotFromOrder,
    checkSpotChange,
  };
}

function sortSpots(spots) {
  if (spots == null) return null;

  let result = [...spots];
  const regex = /\d+/;

  result?.forEach((s) => {
    const match = regex.exec(s.name);

    if (match == null) {
      s.number = s.hidden ? 99999 : 0;
      s.orderField = s.name;
    } else {
      s.number = parseInt(match[0], 10);
      s.orderField = s.name?.replace(s.number, '');
    }
  });

  result = _.orderBy(result, ['number', 'orderField']);

  result?.forEach((s) => {
    delete s.number;
    delete s.orderField;
  });

  return result;
}

export { useSpotManager, sortSpots };
